import React from 'react';
import PropTypes from 'prop-types';
import FormRadioGroupContainer from '../../../redux/containers/FormRadioGroupContainer';
import FormDropdownContainer from '../../../redux/containers/FormDropdownContainer';
import isps from './isps.json';
import landlines from './landlines.json';
import './CurrentConnection.scss';
import ProviderAccountNumber from './ProviderAccountNumber';

const checkNeedEnterProviderAccountNumber = currentBroadbandProvider =>
  currentBroadbandProvider && currentBroadbandProvider !== 1 && currentBroadbandProvider !== 22
  && currentBroadbandProvider !== 23;

const CurrentConnection = props =>
  <section>
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <h3 className="half-charcoal">About your current connection</h3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-sm-6">
          <div className="current-connection-isp-dropdown">
            <FormDropdownContainer
              items={isps}
              name="currentBroadbandProvider"
              className="autotest-current-broadband-provider skinny-dropdown"
              label="Who is your current broadband provider at this address?"
              placeholder="Select your current provider"
            />
          </div>
          {
            checkNeedEnterProviderAccountNumber(props.currentBroadbandProvider) &&
            <ProviderAccountNumber />
          }
          <p>Do you have a landline with your current provider?</p>
          <FormRadioGroupContainer
            name="landline"
            radioButtons={[{
              id: 'yes',
              label: 'Yes',
              autotestClass: 'autotest-yes'
            }, {
              id: 'no',
              label: 'No',
              autotestClass: 'autotest-no'
            }]}
          />
        </div>
      </div>
      {
        props.showExistingLandlineProvider &&
        <div className="row">
          <div className="col-xs-12">
            <div className="row">
              <div className="col-xs-12">
                <div className="current-connection-landline-dropdown">
                  Heads up, you will lose your landline when you move to Skinny Broadband as we don&apos;t offer
                  that service.
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-6">
                <FormDropdownContainer
                  items={landlines}
                  name="existingLandlineProvider"
                  className="autotest-existing-landline-provider skinny-dropdown"
                  label="Who is your landline provider?"
                  placeholder="Who is your landline provider?"
                />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </section>
;

CurrentConnection.propTypes = {
  showExistingLandlineProvider: PropTypes.bool,
  currentBroadbandProvider: PropTypes.string
};

export default CurrentConnection;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/CurrentConnection/CurrentConnection.js
 **/